<template>
	<v-col class="reward">
		<div class="d-flex justify-space-between">
			<div class="text-h5 cl-primary">Testimoni</div>
		</div>
		<div class="pt-1 pb-2 d-flex font-size-10 grey--text">
			<v-icon small color="grey">mdi-format-float-left</v-icon>
			<div class="pl-2">Testimoni</div>
		</div>
		<div class="mt-5">
			<v-row>
				<v-col cols="12">
					<v-card class="pa-3 elevation-0 rounded-xl hover-shadow">
						<v-row>
							<v-col cols="12" class="px-5 pt-5">
								<div class="font-size-14 cl-primary">Form Testimoni</div>
								<v-form ref="formTestimony">
									<v-col cols="12" sm="5" class="px-0">
										<v-autocomplete label="Pilih Tipe" no-data-text="Tidak ada data yang dapat ditampilkan" color="primary" prepend-inner-icon="mdi-format-list-bulleted" :items="type" item-text="text" item-value="value" hide-details="auto" :rules="rules.type" v-model="params.testimony_type"></v-autocomplete>
									</v-col>
									<v-col cols="12" sm="5" class="px-0" v-if="params.testimony_type == 'image'">
										<v-file-input label="Pilih Gambar" accept="image/png, image/jpeg, image/jpg" hide-details="auto" prepend-icon="" prepend-inner-icon="mdi-camera" :clearable="false" :rules="rules.image" v-model="params.testimony_file"></v-file-input>
									</v-col>
									<v-col cols="12" sm="5" class="px-0" v-if="params.testimony_type == 'video'">
										<v-text-field label="URL Video Youtube" color="primary" hide-details="auto" prepend-inner-icon="mdi-link" :rules="rules.video" v-model="params.testimony_url"></v-text-field>
									</v-col>
									<v-col cols="12" class="px-0">
										<v-textarea label="Testimoni Anda" color="primary" rows="5" no-resize hide-details="auto" prepend-inner-icon="mdi-format-float-left" :rules="rules.testimony" v-model="params.testimony"></v-textarea>
									</v-col>
								</v-form>
							</v-col>
						</v-row>
						<v-row justify="end">
							<v-col cols="6" sm="4" class="px-5 pt-0 pb-5 text-right">
								<v-btn large width="120" depressed class="bg-primary white--text rounded-xl" :loading="btnLoading" @click="proccessTestimony">
									<v-icon>mdi-arrow-right-bold-circle</v-icon>
									<span class="pl-2 text-capitalize font-size-11 font-weight-bold">Kirim</span>
								</v-btn>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</div>
	</v-col>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	data() {
		return {
			btnLoading: false,
			type: [
			{ text: 'Gambar', value: 'image' },
			{ text: 'Video', value: 'video' },
			],
			params: {
				testimony_type: 'image',
				testimony_file: null,
				testimony_url: '',
				testimony: '',
			},
			rules: {
				type: [v => !!v || 'Tipe tidak boleh kosong',],
				video: [v => !!v || 'URL Video tidak boleh kosong',],
				testimony: [
					v => !!v || 'Testimoni tidak boleh kosong',
					v => (v && v.length < 500) || 'Testimoni maksimal 500 karakter',
				],
				image: [
					v => !!v || 'Gambar tidak boleh kosong',
					v => (v && v.size > 0) || 'Gambar tidak boleh kosong',
					v => (v && v.size < 3145728) || 'Ukuran Gambar tidak boleh lebih dari 3 MB',
				],
			}
		}
	},
	computed: {
		...mapState('testimony', ['responseSuccess']),
	},
	methods: {
		...mapActions('testimony', ['addTestimony']),

		reset() {
			this.params.testimony_type = 'image'
			this.params.testimony_file = null
			this.params.testimony_url = ''
			this.params.testimony = null
			this.$refs.formTestimony.resetValidation()
		},
		proccessTestimony() {
			if (this.$refs.formTestimony.validate()) {
				this.btnLoading = true
				let formData = new FormData()
				formData.append('testimony_type', this.params.testimony_type)
				formData.append('testimony_file', this.params.testimony_file)
				formData.append('testimony_url', this.params.testimony_url)
				formData.append('testimony', this.params.testimony)

				this.addTestimony(formData).then(() => {
					this.btnLoading = false
					this.reset()
					this.formTestimony
				}).catch(() => {
					this.btn_loading = false
				})
			}
		}
	},
	created(){
		this.$store.dispatch('setPageTitle', `Testimoni`)
	}
};
</script>